// extracted by mini-css-extract-plugin
module.exports = {"root":"AttachmentsList_root__3ExuV"};